export default "__VITE_ASSET__BAvu6AUl__"